import * as React from 'react';

export function CheckIcon() {
  return (
    <svg
      width={72}
      height={72}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={41} cy={41} r={28} fill="#E7F6EA" />
      <circle cx={36} cy={36} r={28} stroke="#49AF5B" strokeWidth={2} />
      <path
        d="m27 35.4 6.742 6.6L46 30"
        stroke="#49AF5B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
